import GroupResource from './group-resource';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';

export default class ManufacturerResource extends GroupResource {
  constructor(init?: Partial<ManufacturerResource>) {
    super(init, 'chemical-manufacturers');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/manufacturer-resource.ts